import { useContext, useState } from "react";
import SellLong from "./sellLong";
import { UserContext } from "../../context/provider";
import SellLongCalculator from "../mostlyUsed/sellLongCalculator";
import axios from "axios";
import { dummyLongData } from "./test";
import { exportToCSV, ManyFileInput } from "../mostlyUsed/mainComponents";

const ProductionCount = () => {
  const [proccessState, setProccessState] = useState(0);
  const [proccessText, setProccessText] = useState("");
  const [fileDatas, setFileDatas] = useState([]);
  const { verifiedCodes } = useContext(UserContext);
  let sellLong = [];
  let finalData = [];
  let kargah = []

  const gradeLimit = 10;
  const minProductionQuantity = 20;

  const groupsPerBranch = {
    heravi: {
      kids: {
        from: 25,
        to: 29,
        factor: {
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
        },
        fillOrder: [25, 26, 27, 28, 29, 25, 26, 27, 28, 29, 25, 26, 27, 28, 29],
        minProduction: { 1: 3, 2: 6 },
      },
      child: {
        from: 30,
        to: 34,
        factor: {
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
        },
        fillOrder: [
          30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32,
          33, 34,
        ],
        minProduction: { 1: 3, 2: 11 },
      },
      female: {
        from: 35,
        to: 40,
        factor: {
          35: 1,
          36: 3,
          37: 4,
          38: 5,
          39: 4,
          40: 3,
        },
        fillOrder: [38, 37, 39, 36, 40, 38, 37, 39, 35, 36, 40],
        minProduction: { 1: 12, 2: 18 },
      },
      male: {
        from: 41,
        to: 45,
        factor: {
          41: 3,
          42: 3,
          43: 2,
          44: 1,
          45: 1,
        },
        fillOrder: [41, 42, 43, 44, 45, 41, 42, 43, 44, 45, 41, 42, 43, 41, 42],
        minProduction: { 1: 6, 2: 12 },
      },
    },
    doomanQuantity: {
      kids: {
        from: 25,
        to: 29,
        factor: {
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
        },
        fillOrder: [25, 26, 27, 28, 29, 25, 26, 27, 28, 29, 25, 26, 27, 28, 29],
        minProduction: { 1: 3, 2: 12 },
      },
      child: {
        from: 30,
        to: 34,
        factor: {
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
        },
        fillOrder: [
          30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32,
          33, 34,
        ],
        minProduction: { 1: 3, 2: 11 },
      },
      female: {
        from: 35,
        to: 40,
        factor: {
          35: 1,
          36: 1,
          37: 2,
          38: 3,
          39: 2,
          40: 2,
        },
        fillOrder: [38, 37, 39, 36, 40, 38, 37, 39, 35, 36, 40],
        minProduction: { 1: 5, 2: 18 },
      },
      male: {
        from: 41,
        to: 45,
        factor: {
          41: 2,
          42: 2,
          43: 1,
          44: 1,
          45: 1,
        },
        fillOrder: [41, 42, 43, 44, 45, 41, 42, 43, 44, 45, 41, 42, 43, 41, 42],
        minProduction: { 1: 3, 2: 12 },
      },
    },
    merdasQuantity: {
      kids: {
        from: 25,
        to: 29,
        factor: {
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
        },
        fillOrder: [25, 26, 27, 28, 29, 25, 26, 27, 28, 29, 25, 26, 27, 28, 29],
        minProduction: { 1: 3, 2: 12 },
      },
      child: {
        from: 30,
        to: 34,
        factor: {
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
        },
        fillOrder: [
          30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32,
          33, 34,
        ],
        minProduction: { 1: 3, 2: 11 },
      },
      female: {
        from: 35,
        to: 40,
        factor: {
          35: 1,
          36: 1,
          37: 1,
          38: 2,
          39: 1,
          40: 1,
        },
        fillOrder: [38, 37, 39, 36, 40, 38, 37, 39, 35, 36, 40],
        minProduction: { 1: 3, 2: 18 },
      },
      male: {
        from: 41,
        to: 45,
        factor: {
          41: 1,
          42: 1,
          43: 1,
          44: 1,
          45: 1,
        },
        fillOrder: [41, 42, 43, 44, 45, 41, 42, 43, 44, 45, 41, 42, 43, 41, 42],
        minProduction: { 1: 2, 2: 12 },
      },
    },
    kargahData: {
      kids: {
        from: 25,
        to: 29,
        factor: {
          25: 1,
          26: 1,
          27: 1,
          28: 1,
          29: 1,
        },
        fillOrder: [25, 26, 27, 28, 29, 25, 26, 27, 28, 29, 25, 26, 27, 28, 29],
        minProduction: { 1: 3, 2: 6 },
      },
      child: {
        from: 30,
        to: 34,
        factor: {
          30: 1,
          31: 1,
          32: 1,
          33: 1,
          34: 1,
        },
        fillOrder: [
          30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32,
          33, 34,
        ],
        minProduction: { 1: 3, 2: 11 },
      },
      female: {
        from: 35,
        to: 40,
        factor: {
          35: 1,
          36: 3,
          37: 4,
          38: 5,
          39: 4,
          40: 3,
        },
        fillOrder: [38, 37, 39, 36, 40, 38, 37, 39, 35, 36, 40],
        minProduction: { 1: 12, 2: 18 },
      },
      male: {
        from: 41,
        to: 45,
        factor: {
          41: 3,
          42: 3,
          43: 2,
          44: 1,
          45: 1,
        },
        fillOrder: [41, 42, 43, 44, 45, 41, 42, 43, 44, 45, 41, 42, 43, 41, 42],
        minProduction: { 1: 6, 2: 12 },
      },
    },
  };

  const groups = {
    kids: {
      from: 25,
      to: 29,
      factor: {
        25: 2,
        26: 2,
        27: 2,
        28: 2,
        29: 2,
      },
      fillOrder: [25, 26, 27, 28, 29, 25, 26, 27, 28, 29, 25, 26, 27, 28, 29],
      minProduction: { 1: 6, 2: 12 },
    },
    child: {
      from: 30,
      to: 34,
      factor: {
        30: 2,
        31: 2,
        32: 2,
        33: 1,
        34: 1,
      },
      fillOrder: [
        30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32,
        33, 34,
      ],
      minProduction: { 1: 5, 2: 11 },
    },
    female: {
      from: 35,
      to: 40,
      factor: {
        35: 1,
        36: 3,
        37: 4,
        38: 5,
        39: 4,
        40: 3,
      },
      fillOrder: [38, 37, 39, 36, 40, 38, 37, 39, 35, 36, 40],
      minProduction: { 1: 12, 2: 18 },
    },
    male: {
      from: 41,
      to: 45,
      factor: {
        41: 3,
        42: 3,
        43: 2,
        44: 1,
        45: 1,
      },
      fillOrder: [41, 42, 43, 44, 45, 41, 42, 43, 44, 45, 41, 42, 43, 41, 42],
      minProduction: { 1: 6, 2: 12 },
    },
  };

  const arraySum = (array) => {
    // console.log(array);

    const sum = array.reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);
    return sum;
  };

  const combineQuantitys = (mainQuantity, reservedQuantity) => {
    // console.log("main quantity: ", mainQuantity);
    // console.log("reserved quantity: ", reservedQuantity);
    const combined = mainQuantity.map((item) => {
      const reservedItem = reservedQuantity.find(
        (reservedItem) => reservedItem.Barcode === item.Barcode
      );
      if (reservedItem) {
        return {
          ...item,
          Quantity: item.Quantity + reservedItem.Quantity,
        };
      }
      return item;
    });
    // console.log("combined quantity: ", combined);
    return combined;
  }

  const getQuantity = async (warehouse) => {
    const res = await axios.post(
      "https://api.hesabfa.com/v1/item/GetQuantity",
      {
        apiKey: "E62BNpYDHmn1K8JFNJG24jDSpTE9ktBP",
        loginToken:
          "3849304732a5e3cfd84a908ffd0b8c1c4e44c804df3692627b127d3f5638d3791105a1df1ddd2f00cb6bf2f36c3d3827",
        warehouseCode: warehouse,
      }
    );
    // console.log(res);
    let filtered = res.data.Result.filter(
      (e) =>
        verifiedCodes.includes(e.Barcode?.substring(0, 2)) &&
        e.Barcode.length === 11
    );

    return filtered;
  };

  const addOldQuantitys = (quantityList) => {
    // console.log("old quantity: ", quantityList);
    if (fileDatas.length > 0) {
      for (let sheet of fileDatas) {
        for (let product in sheet) {
          if (product !== 0) {
            for (let size = 0; size <= 20; size++) {
              const index = quantityList.findIndex(
                (e) => e.Barcode === sheet[product][22] + sheet[0][size]
              );
              if (index >= 0) {
                // console.log(sheet[product][22], sheet[0][size]);
                // console.log("index: ", index, "product: ", product);
                // console.log(quantityList[index].Quantity, sheet[product][size]);
                quantityList[index].Quantity =
                  quantityList[index].Quantity + sheet[product][size];
              }
            }
          }
        }
      }
    }
    // console.log("new quantity: ", quantityList);
    return quantityList;
  };

  const addQuantityToData = (filledQuantity) => {
    for (let i in sellLong[1]) {
      const qIndex = filledQuantity.findIndex(
        (e) => e.Code === sellLong[1][i].code
      );
      sellLong[1][i].quantity =
        qIndex >= 0 ? filledQuantity[qIndex].Quantity : "-";
    }
  };

  const CalculateProduction = (sum, count, i, product, sex, quantityList, sellCount) => {
    const average = sellCount / count;
    console.log("----------------------------------");

    console.log("here we go: ", sex, product);

    console.log("average is this: ", sellCount, "---", count, "---", average);

    // const grade = average > gradeLimit ? 1 : average > 15 ? 2 : 1;
    const grade = !average ? 1 : average > gradeLimit ? 1 : 2;

    let correctBarcode = "";

    const sampleQuantity = {
      25: null,
      26: null,
      27: null,
      28: null,
      29: null,
      30: null,
      31: null,
      32: null,
      33: null,
      34: null,
      35: null,
      36: null,
      37: null,
      38: null,
      39: null,
      40: null,
      41: null,
      42: null,
      43: null,
      44: null,
      45: null,
    }

    let groupQuantity = {};

    // console.log("quantityList: ", quantityList);

    for (let branch of Object.keys(quantityList)) {
      console.log("branch: ", branch);
      console.log("group: ", groupQuantity);
      if((grade === 2) || branch !== "kargahData" ){

        groupQuantity[branch] = { ...sampleQuantity }
        for (let g = groupsPerBranch[branch][sex].from; g <= groupsPerBranch[branch][sex].to; g++) {
          const code = sellLong[1].filter(
            (e) => e.barcode === product.code + g
          )[0]?.code;
          
          // calculates needed quantity of this model and size
          const liveQuantity = quantityList[branch].filter((e) => e.Code === code)[0];
          correctBarcode = liveQuantity?.barcode?.substring(0, 9);
          if (liveQuantity) {
            const needQuantity =
            // groups[sex].factor[g] * grade - liveQuantity.Quantity;
            groupsPerBranch[branch][sex].factor[g] - liveQuantity.Quantity;
            groupQuantity[branch][g] = needQuantity <= 0 ? 0 : needQuantity;
          }
        }
        groupQuantity[branch].total = arraySum(Object.values(groupQuantity[branch]))
      }
    }

    // console.log("group quantity: ", groupQuantity);
    const sortedDataArray = Object.entries(groupQuantity).sort(
      ([, a], [, b]) => a.total - b.total
    );

    for (let i in sortedDataArray) {
      // console.log("branch: ",sortedDataArray[i][0],"data: ", sortedDataArray[i][1]);
      // console.log("kargah: ", kargah);
      for (let g = groups[sex].from; g <= groups[sex].to; g++) {
        // console.log("need: ", sortedDataArray[i][1][g]);
        const thisKargah = kargah.findIndex(e => e.Barcode === (product.code + String(g)))
        const kargahQuantity = kargah[thisKargah]?.Quantity
        if (kargahQuantity > 0) {
          const thisNeedQuantity = sortedDataArray[i][1][g]
          if (kargahQuantity >= thisNeedQuantity) {
            const difference = kargahQuantity - thisNeedQuantity
            sortedDataArray[i][1][g] = 0
            kargah[thisKargah].Quantity = difference
          } else {
            const difference = thisNeedQuantity - kargahQuantity
            sortedDataArray[i][1][g] = difference
            kargah[thisKargah].Quantity = 0
          }
          // console.log("stop here!", kargahQuantity);
        }
        // console.log("kargah: ", thisKargah);

      }


    }

    const totalCountList = Object.keys(groupQuantity);
    // const totalCount = arraySum(totalCountList);
    const totalCount = {}
    // console.log(Object.keys(groupQuantity));

    Object.keys(groupQuantity).forEach((e) => totalCount[e] = arraySum(Object.values(groupQuantity[e])))
    // console.log("old quantity: ", groupQuantity);

    // at least one branch should have minimum need of production
    let needToProduction = false
    for (let i of Object.values(totalCount)) {
      if (i > groups[sex].minProduction[1]) {
      // if (i > groups[sex].minProduction[grade]) {
        needToProduction = true
        break;
      }
    }

    let allGroupQuantity = { ...sampleQuantity }
    for (let i of Object.keys(groupQuantity)) {
      for (let g = groupsPerBranch[i].kids.from; g <= groupsPerBranch[i].male.to; g++) {
        if (groupQuantity[i][g]) {
          allGroupQuantity[g] = allGroupQuantity[g] + groupQuantity[i][g]
        }
      }
    }

    if (needToProduction) {

      let addQuantityIndex = 0;

      //reaches total quantity to min production in this while loop
      while (arraySum(Object.values(allGroupQuantity)) < minProductionQuantity) {
        if (
          minProductionQuantity - arraySum(Object.values(allGroupQuantity)) >
          arraySum(Object.values(groups[sex].factor))
        ) {
          // here will add 1 round of series
          for (let i = groups[sex].from; i <= groups[sex].to; i++) {
            const code = sellLong[1].filter(
              (e) => e.barcode === product.code + i
            )[0]?.code;
            // const liveQuantity = quantityList.filter((e) => e.Code === code)[0];
            // let liveQuantity = 0
            // Object.values(quantityList).forEach(e => liveQuantity = liveQuantity + e.filter((z) => z.Code === code)[0]?.Quantity)
            // if (!(liveQuantity > groups[sex].factor[i] * 3)) {
            if (allGroupQuantity[i]) {
              allGroupQuantity[i] = allGroupQuantity[i] + groups[sex].factor[i];
            } else {
              allGroupQuantity[i] = groups[sex].factor[i];
            }
            // }
          }
        } else {
          let isAdded = false;
          // for(let i = groups[sex].from; i <= groups[sex].to; i++){
          //     if(!groupQuantity[i]){
          //         groupQuantity[i] = 1
          //         isAdded = true
          //         break
          //     }
          // }
          if (!isAdded) {
            const thisSize = groups[sex].fillOrder[addQuantityIndex];
            const code = sellLong[1].filter(
              (e) => e.barcode === product.code + thisSize
            )[0]?.code;
            // const liveQuantity = quantityList.filter((e) => e.Code === code)[0];
            // let liveQuantity = 0
            // Object.values(quantityList).forEach(e => liveQuantity = liveQuantity + e.filter((e) => e.Code === code)[0]?.Quantity)
            // console.log(
            //   "live ",
            //   liveQuantity,
            //   groups[sex].factor[thisSize],
            //   thisSize
            // );
            // if (!(liveQuantity > groups[sex].factor[i] * 3)) {
            allGroupQuantity[thisSize] = allGroupQuantity[thisSize] + 1;
            // }
            addQuantityIndex = addQuantityIndex + 1;
          }
        }
      }

      const oneUniqCode = sellLong[1].filter((e) =>
        e.barcode.includes(product.code)
      )[0].code;
      // console.log("heravi qu: ", quantityList.heravi);

      const correctBarcode = quantityList.heravi.filter(
        (e) => e.Code === oneUniqCode
      )[0]
        ? quantityList.heravi.filter((e) => e.Code === oneUniqCode)[0].Barcode
        : product.code;
      // const correctBarcode = product.code

      addQuantityIndex = 0;
      allGroupQuantity.title = product.title;
      allGroupQuantity.code = correctBarcode?.substring(0, 9);
      allGroupQuantity.sellLong = average ? average : 0;
      allGroupQuantity.grade = grade;
      // console.log("this code: ", allGroupQuantity.code);
      // console.log("new quantity: ", allGroupQuantity);
      // console.log("-----------------------------------");
      finalData.push(allGroupQuantity);
    }

    // console.log(
    //   i,
    //   "group: ",
    //   sex,
    //   "product: ",
    //   product.title,
    //   "grade: ",
    //   grade,
    //   "groupQuantity: ",
    //   groupQuantity
    // );

    // console.log(totalCount);
  };

  const CalculateDatas = (quantityList) => {
    console.log("sell single", sellLong[1]);
    console.log("sell second", sellLong[0]);
    console.log("sell all", sellLong);
    console.log(sellLong[0]);
    for (let product of sellLong[0]) {
      let sum = 0;
      let count = 0;
      let sellCount = 0;
      for (let i = groups.kids.from; i <= groups.male.to; i++) {
        if (!!product[i] && product[i] !== "-") {
          sum = sum + product[i];
          count = count + 1;
          const thisProduct = sellLong[1].find(e => e.barcode === (product.code + i))
          console.log("thisProduct: ", thisProduct);

          sellCount = sellCount + (product[i] / (thisProduct.sell))
          console.log("sellCount: ", sellCount);

        }

        if (groups.kids.to === i) {
          //kids group

          CalculateProduction(sum, count, i, product, "kids", quantityList, sellCount);
          sum = 0;
          count = 0;
          sellCount = 0;
        }
        if (groups.child.to === i) {
          //child group

          CalculateProduction(sum, count, i, product, "child", quantityList, sellCount);
          sum = 0;
          count = 0;
          sellCount = 0;
        }
        if (groups.female.to === i) {
          //female group

          CalculateProduction(sum, count, i, product, "female", quantityList, sellCount);

          sum = 0;
          count = 0;
          sellCount = 0;
        }
        if (groups.male.to === i) {
          //male group

          CalculateProduction(sum, count, i, product, "male", quantityList, sellCount);

          sum = 0;
          count = 0;
          sellCount = 0;
        }
      }
    }
    console.log("enf of CalculateDatas 1:");

  };

  const startAction = async () => {
    const cleanedData = await SellLongCalculator(
      setProccessState,
      setProccessText
    );
    // const cleanedData = JSON.parse(localStorage.getItem("cleanedData"));
    console.log("cleaned data: ", cleanedData);
    // localStorage.setItem("cleanedData", JSON.stringify(cleanedData));

    console.log(cleanedData);

    sellLong = cleanedData;

    setProccessText("در حال دریافت موجودی فعلی");
    // setProccessText("در حال محاسبه میزان مناسب تولید");
    setProccessState(80);
    // const quantityList = await getQuantity();
    const kargahData = await getQuantity(19);
    kargah = kargahData
    const heraviQuantity = await getQuantity(11);
    const merdasQuantity = await getQuantity(18);
    const doomanQuantity = await getQuantity(20);

    const heraviQuantityReserved = await getQuantity(21);
    const merdasQuantityReserved = await getQuantity(22);
    const doomanQuantityReserved = await getQuantity(23);

    const finalHeravi = combineQuantitys(heraviQuantity, heraviQuantityReserved)
    const finalMerdas = combineQuantitys(merdasQuantity, merdasQuantityReserved)
    const finalDooman = combineQuantitys(doomanQuantity, doomanQuantityReserved)
    // console.log("quantity List: ", quantityList);
    // localStorage.setItem("quantityList", JSON.stringify(quantityList));

    // const quantityList = JSON.parse(localStorage.getItem("quantityList"));

    // const filledQuantity = addOldQuantitys(quantityList)

    const filledQuantity = {
      heravi: finalHeravi,
      merdasQuantity: finalMerdas,
      doomanQuantity: finalDooman,
      kargahData: kargahData
    };

    console.log("filledQuantity", filledQuantity);

    CalculateDatas(filledQuantity);
    console.log("enf of CalculateDatas 2:");
    finalData.sort((a, b) => {
      if (a.sellLong < 12) return 1;
      if (b.sellLong < 12) return -1;
      return a.sellLong - b.sellLong;
    });

    console.log("enf of sort:");

    // addQuantityToData(filledQuantity);

    setProccessText("فایل آماده است");
    setProccessState(100);
    console.log("final data: ", finalData);
    console.log("sellLong: ", sellLong[1]);
    exportToCSV(finalData, sellLong[1], "sells");
  };

  return (
    <div style={{ width: "100%", marginTop: 30 }}>
      <button
        style={{
          backgroundColor: "white",
          border: "solid 1px gray",
          padding: 10,
          borderRadius: 10,
          cursor: "pointer",
          fontSize: 15,
        }}
        onClick={startAction}
      >
        شروع ایجاد فایل
      </button>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: 20,
        }}
      >
        <div
          style={{
            width: "80%",
            height: 20,
            backgroundColor: "#dbdbdb",
            borderRadius: 15,
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              width: `${proccessState}%`,
              height: 20,
              backgroundColor: "#00a600",
              borderRadius: 15,
              transition: "all 2s ease-in-out",
            }}
          ></div>
        </div>
        <p>{proccessText}</p>
      </div>
      <ManyFileInput
        title="فایل اکسل انبار حسابفا"
        fileName="hesabfa"
        contextData={setFileDatas}
      />
    </div>
  );
};

export default ProductionCount;
